module.exports = __webpack_public_path__ + "static/hyperv_50.e6d9c98d.png";